import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";

import sorting from "../../Assets/Projects/sorting.png"
import cssGen from "../../Assets/Projects/cssgen.png";
import chat from "../../Assets/Projects/chatApp.png";
import InstagramClone from "../../Assets/Projects/instagram.png";
import ResumeBuilder from "../../Assets/Projects/resumeBuilder.png";
import fileSharingApp from "../../Assets/Projects/fileSharingApp.png";
import socialMedia from "../../Assets/Projects/socialMedia.png";
import bookStore from "../../Assets/Projects/bookSore.png";

// Project Data Array
const projectData = [
  {

    imgPath: cssGen,
    title: "CSS Generator Tool",
    description:
      "A user-friendly CSS Generator tool that allows developers to visually design and preview various CSS styles like gradients, box shadows, borders, and more. Built with React, offering real-time previews and copy-to-clipboard functionality to boost frontend productivity",
      ghLink: "",
      demoLink: "https://css-generator-pi.vercel.app/",
  },
  {
    imgPath: fileSharingApp,
    title: "File Sharing App",
    description:
      "Fast and secure File sharing app. Created using HTML, CSS, and Vanilla JavaScript in frontend and MongoDB cloud database.",
      ghLink: "https://github.com/Saurabhsaxena81/fileshareapp-frontend.git",
      demoLink: "https://fileshareapp-frontend.vercel.app/",
  },
  {
    imgPath: sorting,
    title: "Sorting Visualizer",
    description:
      "An interactive Sorting Algorithm Visualizer built with React, designed to help users understand how different sorting algorithms like Bubble Sort, Merge Sort, and Quick Sort work. It features real-time visual animations and adjustable speed controls to enhance algorithmic learningalong with code.",
      ghLink:"#",
    demoLink: "https://sorting-algo-visualizer-react.vercel.app/",
  },
  {
    imgPath: ResumeBuilder,
    title: "Resume Builder App",
    description:
      "AI-based online resume builder that generates ATS-friendly resumes. Built using React, Node, Express, MongoDB, and AI APIs with secure Google and GitHub authentication.",
      ghLink:"#",
    demoLink: "https://s-react-resume-builder.vercel.app/",
  },
  {
    imgPath: chat,
    title: "Chatting Application",
    description:
      "Personal chat room to share resources and hang out with friends. Built with React.js, Material-UI, and Firebase. Supports real-time messaging, image sharing, and reactions.",
      ghLink: "https://github.com/Saurabhsaxena81/chat-app-frontend.git",
    demoLink: "https://chatify-fawn-sigma.vercel.app/", // Replace this with the actual link

  },
  {
    imgPath: socialMedia,
    title: "Social Media App",
    description:
      "A platform to post and save memories. Includes authentication. Built using MERN stack.",
    ghLink: "https://github.com/Saurabhsaxena81/PinterestV1.git",
   // Replace this with the actual link
  },
  {
    imgPath: InstagramClone,
    title: "Instagram Clone",
    description:
      "A clone of the Instagram app created using React and Firebase.",
    ghLink: "https://github.com/Saurabhsaxena81/Instagram",
    demoLink: "", // Replace this with the actual link
  },
  {
    imgPath: bookStore,
    title: "Online Book Store App",
    description:
      "Online book store where you can take books on rent for study. Built with React, MongoDB, Node.js, and Express. Includes dark/light mode toggle and Tailwind CSS.",
  },

];

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          {projectData.map((project, index) => (
            <Col md={4} className="project-card" key={index}>
              <ProjectCard
                imgPath={project.imgPath}
                isBlog={false}
                title={project.title}
                description={project.description}
                ghLink={project.ghLink}
                demoLink={project.demoLink}
              />
            </Col>
          ))}
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;

// import React from "react";
// import { Container, Row, Col } from "react-bootstrap";
// import ProjectCard from "./ProjectCards";
// import Particle from "../Particle";
// import chat from "../../Assets/Projects/chatApp.jpg";
// import InstagramClone from "../../Assets/Projects/instagram.png";
// import ResumeBuilder from "../../Assets/Projects/resumeBuilder.png";
// import fileSharingApp from "../../Assets/Projects/fileSharingApp.jpg";
// import socialMedia from "../../Assets/Projects/socialMedia.png";
// import bookStore from "../../Assets/Projects/bookSore.png";

// function Projects() {
//   return (
//     <Container fluid className="project-section">
//       <Particle />
//       <Container>
//         <h1 className="project-heading">
//           My Recent <strong className="purple">Works </strong>
//         </h1>
//         <p style={{ color: "white" }}>
//           Here are a few projects I've worked on recently.
//         </p>
//         <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
//           <Col md={4} className="project-card">
//             <ProjectCard
//               imgPath={fileSharingApp}
//               isBlog={false}
//               title="File Sharing App"
//               description="Fast and secure File sharing aap. Created using Html ,CSS ,And Vanilla javascript in frontend and mongodb cloud database."
//               // ghLink="https://github.com/soumyajit4419/Chatify"
//               // demoLink="https://chatify-49.web.app/"
//             />
//           </Col>

//           <Col md={4} className="project-card">
//             <ProjectCard
//               imgPath={bookStore}
//               isBlog={false}
//               title="Online Book Store App"
//               description="Online book store here you can take books on rent for study. created using react ,mongodb ,nodeJs and express js with the functionality of changing theme black and whilet and i use tailwind css to modify it look pretty."
//               // ghLink="https://github.com/soumyajit4419/Bits-0f-C0de"
//               // demoLink="https://blogs.soumya-jit.tech/"
//             />
//           </Col>

//           <Col md={4} className="project-card">
//             <ProjectCard
//               imgPath={ResumeBuilder}
//               isBlog={false}
//               title="Resume Builder App"
//               description="AI based online resume builder app here you can create ATS friendly resum absolutly free .created using react node express and mongodb and ai apis with the secure google and github authentication."
//               // ghLink="https://github.com/soumyajit4419/Editor.io"
//               // demoLink="https://editor.soumya-jit.tech/"
//                 demoLink="https://s-react-resume-builder.vercel.app/"
//             />
//           </Col>

//           <Col md={4} className="project-card">
//             <ProjectCard
//               imgPath={chat}
//               isBlog={false}
//               title="Chatting Application"
//               description="Personal Chat Room or Workspace to share resources and hangout with friends build with react.js, Material-UI, and Firebase. Have features which allows user for realtime messaging, image sharing as well as supports reactions on messages."
//               // ghLink="https://github.com/soumyajit4419/Plant_AI"
//               // demoLink="https://plant49-ai.herokuapp.com/"
//             />
//           </Col>

//           <Col md={4} className="project-card">
//             <ProjectCard
//               imgPath={socialMedia}
//               isBlog={false}
//               title="Social Media App"
//               description="A Place where You can post your memories and save it for later use and can access by username and password."
//               ghLink="https://github.com/Saurabhsaxena81/PinterestV1.git"
//                 // ghLink="https://github.com/soumyajit4419/AI_For_Social_Good"
//               // demoLink="https://www.youtube.com/watch?v=dQw4w9WgXcQ&ab_channel=RickAstley" <--------Please include a demo link here
//             />
//           </Col>

//           <Col md={4} className="project-card">
//             <ProjectCard
//               imgPath={InstagramClone}
//               isBlog={false}
//               title="Instagram Clone"
//               description="This is the instagram clone here i tried to colne instagram app."
//                 ghLink="https://github.com/Saurabhsaxena81/Instagram"
//               // ghLink="https://github.com/soumyajit4419/Face_And_Emotion_Detection"
//               // demoLink="https://blogs.soumya-jit.tech/"      <--------Please include a demo link here
//             />
//           </Col>
//         </Row>
//       </Container>
//     </Container>
//   );
// }

// export default Projects;
